import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent, type Icon } from '@sb/ui/icon';
import { clsx } from 'clsx';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'chapter-item',
  imports: [IconComponent, TranslatePipe],
  template: `
    <sb-icon class="mt-1 ml-1 shrink-0" [name]="icon" />
    <div class="text-base">
      {{ text }}

      @if (description) {
        <p class="mb-0 font-normal text-support">
          {{ description }}
          @if (learnMoreLink) {
            <span class="font-semibold text-brand">
              <a target="_blank" [href]="learnMoreLink">{{ 'Learn more' | translate }}</a>
            </span>
          }
        </p>
      }
    </div>
  `,
})
export class ChapterItemComponent {
  @HostBinding('class')
  hostClasses = clsx('flex items-start gap-2 p-1.5');

  @Input()
  icon: Icon = 'check';

  @Input()
  text: string | SafeHtml;

  @Input()
  learnMoreLink: string;

  @Input()
  description: string | SafeHtml;
}
